// extracted by mini-css-extract-plugin
export default {"about":"About_about__xc8+8","container":"About_container__3gdro","link":"About_link__-tR0v","descr":"About_descr__TvYDg"};